<template>
  <div>
    <h2>Компании</h2>

    <!-- buttons -->
    <b-row class="my-3">
      <b-col class="d-flex justify-content-between">
        <b-button
          v-b-modal.modal-1
          @click="onCreateButton"
          size="sm"
        >
          Добавить
        </b-button>
        <b-button
          variant="outline-primary"
          size="sm"
          style="border: none;"
          @click="isShowFilters = !isShowFilters"
        >
          <b-icon icon="filter" />
          Показать фильтр
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <!-- search form -->
        <search-form
          :error-result="errorResult"
          :message-result="messageResult"
          :search-query="searchQuery"
          :submit-search="submitSearch"
          :reset-search="resetSearch"
          :is-show-filters="isShowFilters"
        />
      </b-col>
    </b-row>

    <!-- modal -->
    <b-modal id="modal-1" size="lg" title="Новая компания" hide-footer>
      <b-form @submit="createCompany" size="sm">
        <b-form-group label="Название:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              type="text"
              v-model="form.title"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="ИНН:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              type="text"
              v-model="form.inn"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Web-сайт:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              placeholder="http://"
              type="url"
              v-model="form.website"
          ></b-form-input>
        </b-form-group>
        <b-alert v-model="error" dismissible variant="danger">{{message}}</b-alert>
        <loading-button :is-busy="isBusyButton" text="Создать"></loading-button>
      </b-form>
    </b-modal>

    <!-- table -->
    <div>
      <b-table striped hover small show-empty ref="table"
           :items="tableDataProvider"
           :fields="fields"
           :busy.sync="isBusy"
           empty-text="Нет компаний"
           empty-filtered-text="Не найдено"
           :per-page="perPage"
           :current-page="currentPage">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Загрузка...</strong>
          </div>
        </template>
        <template v-slot:cell(title)="data">
          <router-link :to="{ name: 'Company', params: { id: data.item.id }}">{{ data.value }}</router-link>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button-group>
            <b-button v-on:click="show(data.item.id)" variant="primary" size="sm">
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button v-on:click="remove(data.item.id)" variant="danger" size="sm">
              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-pagination align="center"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
  import LoadingButton from "../components/LoadingButton";
  import SearchForm from "../components/SearchForm";

  export default {
    name: "Companies",
    components: {SearchForm, LoadingButton},
    data() {
      return {
        searchQuery: {
          query: '',
          tags: [],
          created_from: null,
          created_to: null
        },
        isBusy: false,
        isBusyButton: false,
        totalRows: 1,
        errorResult: null,
        messageResult: '',
        perPage: 20,
        currentPage: 1,
        error: false,
        message: '',
        fields: [
          {key: 'title', label: 'Название'},
          {key: 'actions', label: 'Действия'}
        ],
        items: [],
        form: {
          title: '',
          inn: '',
          website: ''
        },
        isShowFilters: false,
      }
    },
    methods: {
      onCreateButton() {
        this.form.title = '';
        this.form.inn = '';
        this.form.website = '';
      },
      createCompany(evt) {
        evt.preventDefault();
        this.error = false;
        this.isBusyButton = true;
        this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/companies/', JSON.stringify(this.form)
        ).then((response) => {
          this.isBusyButton = false;
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.$bvModal.hide('modal-1');
              this.$refs.table.refresh();
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
      },
      submitSearch(evt) {
        evt.preventDefault();
        this.$refs.table.refresh();
      },
      resetSearch(evt) {
        evt.preventDefault();
        this.searchQuery.query = '';
        this.searchQuery.tags = [];
        this.searchQuery.created_from = null;
        this.searchQuery.created_to = null;
        this.$refs.table.refresh();
      },
      tableDataProvider(ctx) {
        const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/companies/?page=' +
          ctx.currentPage + '&perpage=' + ctx.perPage + "&query=" + this.searchQuery.query +
          "&created_from=" + this.searchQuery.created_from +
          "&created_to=" + this.searchQuery.created_to +
          "&tags=" + JSON.stringify(this.searchQuery.tags));
        return promise.then(response => {
          this.items = response.data.companies;
          this.totalRows = response.data.totalRows;
          return this.items || []
        }).catch((error) => {
          console.log(error);
          this.items = [];
          this.totalRows = 0;
          return this.items || []
        });
      },
      remove(id) {
        if (confirm("Удалить компанию #" + id + "?")) {
          this.error = false;
          this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/companies/' + id, {}).then((response) => {
            if (response) {
              if (response.data.error === false) {
                this.error = false;
                this.$refs.table.refresh()
              } else {
                console.log(response.data.message);
              }
            }
          })
        }
      },
      show(id) {
        this.$router.push({name: 'Company', params: {id: id}});
      }
    }
  }
</script>

